// Mock projects with cover images (Unsplash, stable photo IDs)
export const mockProjects = [
  {
    id: "proj_codex_skills",
    title: "Top 10 Codex Skills",
    description: "Authority series teaching the new operator-class skill primitives.",
    content_type: "agent_campaign",
    platforms: ["linkedin", "x", "youtube_shorts"],
    asset_count: 7,
    status: "needs_review",
    progress: 0.62,
    updated_at: "2026-01-22T14:11:00Z",
    pillars: ["AI agents", "Skills", "Workflow design"],
    owner: "Adam",
    cover_image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=720&q=70&auto=format&fit=crop",
  },
  {
    id: "proj_hvac_voice",
    title: "AI Voice Agents for HVAC Contractors",
    description: "Lead-qualification voice agents for service businesses — case study angle.",
    content_type: "agent_campaign",
    platforms: ["linkedin", "blog", "x"],
    asset_count: 5,
    status: "approved",
    progress: 0.84,
    updated_at: "2026-01-22T08:32:00Z",
    pillars: ["Voice agents", "SMB", "Lead-gen"],
    owner: "Adam",
    cover_image: "https://images.unsplash.com/photo-1581094271901-8022df4466f9?w=720&q=70&auto=format&fit=crop",
  },
  {
    id: "proj_skills_thesis",
    title: "Why Skills Are the Missing Layer in Agent Workflows",
    description: "Long-form thesis + cross-platform repurposed cuts.",
    content_type: "blog_writer",
    platforms: ["blog", "linkedin", "threads"],
    asset_count: 4,
    status: "draft",
    progress: 0.41,
    updated_at: "2026-01-21T19:02:00Z",
    pillars: ["Thesis", "Skills", "Agents"],
    owner: "Adam",
    cover_image: "https://images.unsplash.com/photo-1545239351-1141bd82e8a6?w=720&q=70&auto=format&fit=crop",
  },
  {
    id: "proj_smb_content",
    title: "Repurposed Blog: AI Content Systems for SMBs",
    description: "Turn the long-form blog into a 7-asset content week.",
    content_type: "repurpose",
    platforms: ["linkedin", "x", "instagram", "youtube_shorts"],
    asset_count: 8,
    status: "scheduled",
    progress: 0.95,
    updated_at: "2026-01-21T11:50:00Z",
    pillars: ["SMB", "Content systems", "Automation"],
    owner: "Adam",
    cover_image: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=720&q=70&auto=format&fit=crop",
  },
  {
    id: "proj_one_to_ten",
    title: "One Idea, Ten Pieces: My Content Stack",
    description: "Behind-the-scenes of the the workspace content engine itself.",
    content_type: "agent_campaign",
    platforms: ["linkedin", "x", "youtube_shorts", "threads"],
    asset_count: 6,
    status: "draft",
    progress: 0.28,
    updated_at: "2026-01-20T16:21:00Z",
    pillars: ["Build-in-public", "Workflow", "Systems"],
    owner: "Adam",
    cover_image: "https://images.unsplash.com/photo-1455390582262-044cdead277a?w=720&q=70&auto=format&fit=crop",
  },
];
